import React from 'react'
// import { STYLES, COLORS } from 'x/config/styles'

import XIcon from './XIcon'

const AddIcon = (props) => <XIcon name='add' {...props} />

export default AddIcon
